<template>
  <div class="app-container main-page">
    <div class="notes-box">
      <img v-asset="'homeHolder'" class="holder-img" />
      <!--      <p></p>-->
      <h1 class="welcome-title">欢迎来到{{ appName }}</h1>
      <el-button @click="linkToOrder" type="primary" plain>前往工单管理</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  computed: {
    appName() {
      return this.$store.state.app.appName
    }
  },
  methods: {
    linkToOrder() {
      this.$perHistory.replace(this.$pathKeys.RepairOrder)
    }
  }
}
</script>

<style scoped lang="scss">
.notes-box {
  /*padding: 15px 20px;*/
  text-align: center;
  margin: 0 auto;
  .holder-img {
    height: 50vh;
  }
  .welcome-title {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/welcome/Welcome.vue